import { useState } from "react";

export default function MapControlToggle({ options, onChange }) {
  const [selectedOption, setSelectedOption] = useState(0);

  const handleClick = (index) => {
    setSelectedOption(index);
    if (onChange) onChange(index);
  };

  return (
    <div className="bg-alpha flex px-1 xl:px-3 py-1 xl:py-2 text-tiny xl:text-xs">
      {options.map((option, index) => (
        <div
          key={option}
          className={`uppercase cursor-pointer mr-3 ${
            selectedOption === index ? "text-black" : "text-gamma"
          }`}
          onClick={() => handleClick(index)}
        >
          {option}
        </div>
      ))}
    </div>
  );
}
